var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};

// src/addDataLayerEntry.ts
var addDataLayerEntry = (event, parameters) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(__spreadValues({
    event
  }, parameters));
};

// src/addEventEntry.ts
var Events = /* @__PURE__ */(Events2 => {
  Events2["PageView"] = "gaPageview";
  Events2["Event"] = "gaEvent";
  Events2["Eec"] = "gaEventEec";
  return Events2;
})(Events || {});
var addEventEntry = _ref => {
  let {
    eventCategory,
    eventAction,
    eventLabel,
    eventNonInteraction
  } = _ref;
  addDataLayerEntry("gaEvent", {
    gaEvent: {
      eventCategory,
      eventAction,
      eventLabel,
      eventNonInteraction
    }
  });
};

// src/addNewEntry.ts
var addNewEntry = _ref2 => {
  let {
    eventCategory,
    eventAction,
    eventLabel = void 0,
    eventValue = void 0,
    eventNonInteraction = false
  } = _ref2;
  addDataLayerEntry("gaEvent", {
    gaEvent: {
      eventCategory,
      eventAction,
      eventLabel,
      eventValue,
      eventNonInteraction
    }
  });
};

// src/addPageViewEntry.ts
var addPageViewEntry = _ref3 => {
  let {
    path,
    query = ""
  } = _ref3;
  addDataLayerEntry("gaPageview", {
    page: {
      path,
      query: query === "" ? void 0 : query
    }
  });
};
export { Events, addDataLayerEntry, addEventEntry, addNewEntry, addPageViewEntry };